module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "vw-list__item"
  }, [(_vm.hasRouter && _vm.link !== "javascript:;") ? _c('router-link', {
    class: [{
      'weui-cell_access': _vm.isLink,
      'in-transition': _vm.inTransition
    }, 'weui-cell vw-list-content'],
    staticStyle: {
      "transform": "translateX(0px)",
      "-webkit-transform": "translateX(0px)"
    },
    attrs: {
      "to": _vm.link
    },
    nativeOn: {
      "click": function($event) {
        _vm.onItemClick($event)
      },
      "touchstart": function($event) {
        _vm.touchStart($event)
      },
      "touchmove": function($event) {
        _vm.touchMove($event)
      },
      "touchend": function($event) {
        _vm.touchEnd($event)
      }
    }
  }, [(_vm.img) ? _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('img', {
    staticStyle: {
      "width": "25px",
      "height": "25px",
      "object-fit": "cover",
      "margin-right": "5px",
      "display": "block"
    },
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('div', {
    staticClass: "weui-cell__hd vw-list-icon",
    style: (_vm.colorObj)
  }, [_c('i', {
    class: _vm.icon,
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_vm._v(_vm._s(_vm.desc))])]) : _vm._e(), _vm._v(" "), (!_vm.hasRouter || _vm.link === "javascript:;") ? _c('a', {
    class: [{
      'weui-cell_access': _vm.isLink,
      'in-transition': _vm.inTransition
    }, 'weui-cell vw-list-content'],
    staticStyle: {
      "transform": "translateX(0px)",
      "-webkit-transform": "translateX(0px)"
    },
    attrs: {
      "href": _vm.link
    },
    on: {
      "click": _vm.onItemClick,
      "touchstart": _vm.touchStart,
      "touchmove": _vm.touchMove,
      "touchend": _vm.touchEnd
    }
  }, [(_vm.img) ? _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('img', {
    staticStyle: {
      "width": "25px",
      "height": "25px",
      "object-fit": "cover",
      "margin-right": "5px",
      "display": "block"
    },
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('div', {
    staticClass: "weui-cell__hd vw-list-icon",
    style: (_vm.colorObj)
  }, [_c('i', {
    class: _vm.icon,
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft"
  }, [_vm._v(_vm._s(_vm.desc))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vw-buttons"
  }, [_vm._t("default")], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-577fe028!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/list/list-item.vue
// module id = 246
// module chunks = 0